import { Fn, min, mix, mul, screenUV, smoothstep } from "three/tsl"
import * as THREE from "three/webgpu"

export const alphaFalloff = Fn(
  ([currentOpacity, lowOpacityThreshold, lowOpacity]: [
    THREE.Node,
    THREE.UniformNode<number>,
    THREE.UniformNode<number>,
  ]) => {
    const isPositive = smoothstep(lowOpacityThreshold, 1, screenUV) // Returns 1 if x > 0, else 0

    const reducedOpacity = mul(currentOpacity, lowOpacity)
    return mix(currentOpacity, reducedOpacity, isPositive)
  },
)

export const edgeFade = Fn(
  ([currentOpacity, fadeStartMargin, fadeEndMargin, overallOpacity]: [
    THREE.Node,
    THREE.UniformNode<number>,
    THREE.UniformNode<number>,
    THREE.UniformNode<number>,
  ]) => {
    // Calculate distance from left edge (screenUV.x goes from 0 to 1)
    const distFromLeft = screenUV.x
    // Calculate distance from right edge
    const distFromRight = screenUV.x.oneMinus()
    // Take minimum distance to nearest edge
    const distToNearestEdge = min(distFromLeft, distFromRight)

    // Apply fade: 0 to fadeStartMargin = invisible, fadeStartMargin to fadeEndMargin = smoothstep fade, above fadeEndMargin = fully visible
    const edgeFadeOpacity = smoothstep(
      fadeStartMargin,
      fadeEndMargin,
      distToNearestEdge,
    )

    // Combine with current opacity and overall opacity
    return mul(currentOpacity, edgeFadeOpacity, overallOpacity)
  },
)
